import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import Input from '../../../components/Inputs/Input/Input';
import Modal from '../../../components/Modals/Modal/Modal';
import * as Types from '../../../../utils/types/Types';
import * as Body from '../Styles';
import * as defines from '../../../../utils/defines/Defines';
import * as Functions from '../../../../utils/functions/Functions';
import Button from '../../../components/Buttons/Button/Button';
import { State } from '../../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { AcessLevelProps } from '../../../redux/acessLevel/actionsType';
import axios from 'axios';
import { verifyEmail } from '../../../../utils/functions/Functions';
import { useNavigate } from 'react-router-dom';
import SearchIcon from '../../../../assets/icons/Search.svg';

type ModalDeleteProps = {
	toggle: Dispatch<SetStateAction<boolean>>;
	idUsuario: string;
	nome: String;
	action: any;
	nomeFilial?: string;
};

export const HardDelete: React.FC<ModalDeleteProps> = ({
	toggle,
	idUsuario,
	nome,
	action,
	nomeFilial = 'atual',
}) => {
	return (
		<Modal title="Deletar Usuário">
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
				}}
			>
				<Body.Text style={{ marginBottom: '20px' }}>
					Tem certeza que deseja excluir o usuário{' '}
					<strong>{nome}</strong>?
					<br />
					Essa ação removerá o usuário permanentemente do Conecta e não poderá ser desfeita.
				</Body.Text>
				<Body.Row>
					<Button
						text="Deletar"
						width={200}
						color="red"
						action={() => action()}
					/>
					<Button
						text="Cancelar"
						width={200}
						action={() => toggle(false)}
					/>
				</Body.Row>
			</div>
		</Modal>
	);
};

export default HardDelete